module.exports = __webpack_public_path__ + "img/contactUser.71faac08.svg";